function rot13_reverse(s) {
  return s.replace(/[a-zA-Z]/g, function(c) {
    return String.fromCharCode((c<="Z"?90:122)>=(c=c.charCodeAt(0)+13)?c:c-26);
  });
}

const emailaddresses = document.querySelectorAll('.emailaddress');

setTimeout(function(){
  emailaddresses.forEach((email) => {
    email.innerHTML =  rot13_reverse(email.innerHTML);
    email.setAttribute('href', rot13_reverse(email.getAttribute('href')) );
    email.classList.add('visible');
  });

}, 400);